import { type JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { Text } from '@videoblocks/design-system';

export interface ModelSelectInfoProps {
    name: string;
    description: string;
    disabled?: boolean;
    className?: string;
}

export function ModelSelectInfo({ name, description, disabled, className }: ModelSelectInfoProps): JSX.Element {
    return (
        <div
            className={twMerge(
                'flex min-w-0 flex-1 flex-col items-start',
                disabled && 'dark:text-neutral-dark-600',
                className,
            )}
        >
            <Text fontSize="sm" className={twMerge('text-wrap text-left', disabled && 'dark:text-neutral-dark-600')}>
                {name}
            </Text>
            <Text
                fontSize="xs"
                fontWeight="regular"
                className={twMerge('text-wrap text-left', disabled && 'dark:text-neutral-dark-600')}
            >
                {description}
            </Text>
        </div>
    );
}
